<template>
  <b-modal id="assignedUsersModal" ref="view-assigned-users-modal" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" scrollable @show="fetchAssignedUsers()"  @hide="resetModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'users']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close();resetModal();"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template v-if="assignedUsers" slot="default">
      <template v-if="!isBusy">
        <template v-if="assignedUsers.length">
          <template v-if="searching">
            <template v-if="matchingUsers.length">
              <b-list-group>
                <b-list-group-item href="#" v-for="assignedUser in matchingUsers" :key="assignedUser.id" class="flex-column align-items-start">
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{assignedUser.email}}</h5>
                  </div>
                  <p class="mb-1">{{t('name', 'name')}}: {{(assignedUser.name)? assignedUser.name : t('noNameGiven', 'noNameGiven')}}</p>
                  <p class="mb-1">{{t('panPrincipleAccess', 'panPrincipleAccess')}}: {{(assignedUser.pan_principle_access)? t('yes', 'yes') : t('no', 'no')}}</p>
                  <p class="mb-1">{{t('userLevel', 'userLevel')}}: {{t(userLevelName(assignedUser.level), userLevelName(assignedUser.level))}}</p>
                  <p class="mb-1">{{t('chosenPrinciple', 'chosenPrinciple')}}: {{modal.principleData.name}}</p>
                  <p class="mb-1 d-flex justify-content-between mt-5">
                    <button v-if="assignedUser.pan_principle_access == 1" class="btn btn-danger" type="button" @click="disablePanPrincipleAccess(assignedUser.id)">
                      <fontAwesomeIcon :icon="['fa', 'minus-circle']" class="text-light mr-2"/>{{t('disablePanPrincipleAccess', 'disablePanPrincipleAccess')}}
                    </button>
                    <button v-else class="btn btn-primary" type="button" @click="enablePanPrincipleAccess(assignedUser.id)">
                      <fontAwesomeIcon :icon="['fa', 'plus-circle']" class="text-light mr-2"/>{{t('enablePanPrincipleAccess', 'enablePanPrincipleAccess')}}
                    </button>
                    <button class="btn btn-danger" type="button" @click="withdrawPrinciple(assignedUser.id, modal.principleData.id)">
                      <fontAwesomeIcon :icon="['fa', 'times-circle']" class="text-light mr-2"/>{{t('withdrawPrinciple', 'withdrawPrinciple')}}
                    </button>
                  </p>
                </b-list-group-item>
              </b-list-group>
            </template>
            <template v-else>
              <p class="text-center">{{t('noAssignableUserFound', 'noAssignableUserFound')}}</p>
            </template>
          </template>
          <template v-else>
            <b-list-group>
              <b-list-group-item href="#" v-for="assignedUser in assignedUsers" :key="assignedUser.id" class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1">{{assignedUser.email}}</h5>
                </div>
                <p class="mb-1">{{t('name', 'name')}}: {{(assignedUser.name)? assignedUser.name : t('noNameGiven', 'noNameGiven')}}</p>
                <p class="mb-1">{{t('panPrincipleAccess', 'panPrincipleAccess')}}: {{(assignedUser.pan_principle_access)? t('yes', 'yes') : t('no', 'no')}}</p>
                <p class="mb-1">{{t('userLevel', 'userLevel')}}: {{t(userLevelName(assignedUser.level), userLevelName(assignedUser.level))}}</p>
                <p class="mb-1">{{t('chosenPrinciple', 'chosenPrinciple')}}: {{modal.principleData.name}}</p>
                <p class="mb-1 d-flex justify-content-between mt-5">
                  <button v-if="assignedUser.pan_principle_access == 1" class="btn btn-danger" type="button" @click="disablePanPrincipleAccess(assignedUser.id)">
                    <fontAwesomeIcon :icon="['fa', 'minus-circle']" class="text-light mr-2"/>{{t('disablePanPrincipleAccess', 'disablePanPrincipleAccess')}}
                  </button>
                  <button v-else class="btn btn-primary" type="button" @click="enablePanPrincipleAccess(assignedUser.id)">
                    <fontAwesomeIcon :icon="['fa', 'plus-circle']" class="text-light mr-2"/>{{t('enablePanPrincipleAccess', 'enablePanPrincipleAccess')}}
                  </button>
                  <button class="btn btn-danger" type="button" @click="withdrawPrinciple(assignedUser.id, modal.principleData.id)">
                    <fontAwesomeIcon :icon="['fa', 'times-circle']" class="text-light mr-2"/>{{t('withdrawPrinciple', 'withdrawPrinciple')}}
                  </button>
                </p>
              </b-list-group-item>
            </b-list-group>
          </template>
        </template>
        <template v-if="!assignedUsers.length">
          <p class="text-center">{{t('noAssignedUserFound', 'noAssignedUserFound')}}</p>
        </template>
      </template>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <div class="col-12 row align-items-center justify-content-between m-0">
        <b-form-input v-if="assignedUsers.length" id="search-key" class="col-5 m-0" v-model="searchKey" :placeholder="t('searchInUsersByEmail', 'searchInUsersByEmail')"></b-form-input>
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel();resetModal();">
          <fontAwesomeIcon :icon="['fa', 'times-circle']" class="text-light mr-2"/>{{ t('closeButtonText', 'closeButtonText')}}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalAssignedUsers',
  inject: [
    'modal',
    'resetModal',
    'userLevelName',
    'refreshResults'
  ],
  data () {
    return {
      isBusy: false,
      searchKey: '',
      matchingUsers: []
    }
  },
  computed:{
    assignedUsers() {
        return this.$store.getters['principalStore/getAssignedUsers']
    },
    principalUserLevel:{
      get: function () {
        return this.$store.getters['principalStore/getPrincipalUserLevel']
      },
      set: function (newLevel) {
        this.$store.commit('principalStore/setPrincipalUserLevel', newLevel)
      }
    },
    searching() {
      if(this.searchKey != '') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    searchKey(key) {
      this.searchInUsersByEmail(key)
    }
  },
  methods:{
    disablePanPrincipleAccess(userId) {
      this.$store.dispatch('principalStore/disablePanPrincipleAccess', {userId}).then(
      () => {
          this.fetchAssignedUsers(false)
        }
      )
    },
    enablePanPrincipleAccess(userId) {
      this.$store.dispatch('principalStore/enablePanPrincipleAccess', {userId}).then(
        () => {
          this.fetchAssignedUsers(false)
        }
      )
    },
    withdrawPrinciple(userId, principleId) {
      this.$store.dispatch('principalStore/withdrawPrincipleFromUser', {userId, principleId}).then(
        () => {
          this.fetchAssignedUsers(true)
        }
      )
    },
    fetchAssignedUsers(doRefresh) {
      this.isBusy = true
      this.searchKey = ''
      this.$store.dispatch('principalStore/getAssignedUsers', {principleUsersLevel: this.principalUserLevel, principle: this.modal.principleData.id}).then(
        () => {
          this.isBusy = false
          if(doRefresh) {
            this.refreshResults(true)
          }
        }
      )
    },
    searchInUsersByEmail(key) {
      let allUsers = this.assignedUsers
      let matchingUsers = []
      for (let i = 0; i < allUsers.length; i++) {
        let currentEmail = allUsers[i].email
        currentEmail = currentEmail.toLowerCase()
        key = key.toLowerCase()
        if(currentEmail.includes(key)) {
          matchingUsers.push(allUsers[i])
        }
      }
      this.matchingUsers = matchingUsers
    }
  },
  created() {
  },
  components:{
  }
}
</script>

<style scoped>
.modal-open #assignedUsersModal___BV_modal_outer_ >>> .modal-content{
  min-width: 700px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #assignedUsersModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}
.modal-open #assignedUsersModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
</style>
